import * as yup from "yup";

export const paymentFormSchema = yup.object({
  type: yup
    .string()
    .required("required")
    .oneOf(["payment", "event", "owner"] as const),
  amount: yup
    .number()
    .transform((value, originalValue) =>
      originalValue === "" || originalValue === null ? undefined : value,
    )
    .typeError("required")
    .required("required")
    .moreThan(0, "amountMustBePositive"),
  payment_method_id: yup
    .number()
    .transform((value, originalValue) =>
      originalValue === "" || originalValue === null ? undefined : value,
    )
    .when("type", {
      is: "payment",
      then: (schema) =>
        schema.typeError("required").required("required").moreThan(0, "required"),
      otherwise: (schema) => schema.nullable().optional(),
    }),
  date: yup.date().when("type", {
    is: (value: string) => value !== "event",
    then: (schema) => schema.required("required"),
    otherwise: (schema) => schema.nullable().optional(),
  }),
  eventId: yup
    .number()
    .transform((value, originalValue) =>
      originalValue === "" || originalValue === null ? undefined : value,
    )
    .when("type", {
      is: "event",
      then: (schema) =>
        schema.typeError("required").required("required").moreThan(0, "required"),
      otherwise: (schema) => schema.nullable().optional(),
    }),
  ownerId: yup
    .number()
    .transform((value, originalValue) =>
      originalValue === "" || originalValue === null ? undefined : value,
    )
    .when("type", {
      is: "owner",
      then: (schema) =>
        schema.typeError("required").required("required").moreThan(0, "required"),
      otherwise: (schema) => schema.nullable().optional(),
    }),
  note: yup.string().nullable(),
});

export type PaymentFormValues = yup.InferType<typeof paymentFormSchema>;

export const paymentFormDefaultValues: PaymentFormValues = {
  type: "payment",
  payment_method_id: undefined as unknown as number,
  amount: 0,
  date: undefined as unknown as Date,
  eventId: undefined as unknown as number,
  ownerId: undefined as unknown as number,
  note: "",
};
